import {
  CheckCircleFilled,
  EnvironmentOutlined,
  MailOutlined,
  PhoneOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Flex,
  Form,
  Input,
  InputNumber,
  Row,
  Typography,
} from "antd";
import { contactUsMap } from "../assets";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import emailjs from "emailjs-com";
import AWS from "aws-sdk";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const useQuery = () => new URLSearchParams(useLocation().search);

const ContactUs = () => {
  const [emailForm] = Form.useForm();
  const query = useQuery();

  useEffect(() => {
    const emailParam = query.get("email");
    if (emailParam) {
      emailForm.setFieldsValue({ email: emailParam });
    }
  }, []);

  const handleSubmit = async (values) => {
    //   const emailData = {
    //     from_name: values.last_name
    //       ? values.first_name + " " + values.last_name
    //       : values.first_name,
    //     reply_to: values.email,
    //     phone_number: values.phone_number,
    //     subject: values.subject,
    //     message: values.message,
    //     //   to_email: "saralvijay99@gmail.com",
    //   };

    //   emailjs
    //     .send(
    //       "service_iq6l00v", // Replace with your Email.js Service ID
    //       "template_r75fswi", // Replace with your Email.js Template ID
    //       emailData,
    //       "apyNSHc2lRW27iPjK" // Replace with your Email.js Public Key
    //     )
    //     .then(() => {
    //       console.log("Email sent successfully!");
    //       emailForm.resetFields();
    //     })
    //     .catch((error) => {
    //       console.error("Email sending failed:", error);
    //     });

    // Configure AWS SES (Use environment variables)
    // AWS.config.update({
    //   accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    //   secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
    //   region: process.env.REACT_APP_AWS_REGION,
    // });

    // const ses = new AWS.SES({ apiVersion: "2010-12-01" });

    // const emailParams = {
    //   Source: process.env.REACT_APP_SENDER_EMAIL,
    //   Destination: { ToAddresses: [process.env.REACT_APP_RECEIVER_EMAIL] },
    //   Message: {
    //     Subject: { Data: `New Contact: ${values.subject}` },
    //     Body: {
    //       Text: {
    //         Data: `
    //           Name: ${values.first_name} ${values.last_name || ""}
    //           Email: ${values.email}
    //           Phone: ${values.phone_number}
    //           Message: ${values.message}
    //         `,
    //       },
    //     },
    //   },
    // };

    // try {
    //   await ses.sendEmail(emailParams).promise();
    //   emailForm.resetFields();
    // } catch (error) {
    //   console.error("AWS SES Error:", error);
    // } finally {
    // }

    try {
      const response = await axios.post(
        "https://twdicnt3sdcrflfk367fontgb40hpwbw.lambda-url.ap-south-1.on.aws/",
        {
          name: values.first_name + " " + (values.last_name || ""),
          email: values.email,
          phone: values.phone_number,
          message: values.message,
          subject: values.subject,
        }
      );
      alert("Email sent successfully!");
    } catch (error) {
      console.error("Error sending email:", error);
      // alert("Failed to send email.");
    }
  };

  return (
    <div style={{ background: "white" }}>
      <div className="contact-header">
        <div
          className="section-heading center-text"
          style={{ color: "#211C70", marginBottom: "20px" }}
        >
          Contact Us
        </div>
        <div className="contact-subheading">
          We’re here to help! Whether you have questions, feedback, or need
          assistance, our team is ready to support you.
        </div>
      </div>
      <div className="section-content contact-content">
        <Row gutter={20}>
          <Col lg={12}>
            <Card className="contact-card" style={{ marginBottom: "20px" }}>
              <div className="contact-card-heading">Contact Info</div>
              <div className="card-content-text" style={{ marginTop: "32px" }}>
                <PhoneOutlined
                  style={{
                    color: "#635AD9",
                    marginRight: "4px",
                    marginTop: "3px",
                  }}
                />{" "}
                +91-9148690051
              </div>
              <div className="card-content-text">
                <MailOutlined
                  style={{
                    color: "#635AD9",
                    marginRight: "4px",
                    marginTop: "3px",
                  }}
                />{" "}
                contactus@cloverbaytechnologies.com
              </div>
            </Card>
            <Card className="contact-card">
              <div className="contact-card-heading">
                Talk to our team today to:
              </div>
              <div className="contact-sub-text">
                Our experts will provide tailored solutions to ensure efficient
                and secure cloud operations for your organization.
              </div>
              <Flex align="flex-start" style={{ marginTop: "32px" }}>
                <CheckCircleFilled className="contact-list-icon" />{" "}
                <div className="card-content-text">
                  Understand how our API product may fulfill your needs
                </div>
              </Flex>
              <Flex align="flex-start">
                <CheckCircleFilled className="contact-list-icon" />{" "}
                <div className="card-content-text">
                  Discover the capabilities and get answers to your questions
                </div>
              </Flex>
              <Flex align="flex-start">
                <CheckCircleFilled className="contact-list-icon" />{" "}
                <div className="card-content-text">
                  Get a customized quote for your busines
                </div>
              </Flex>
            </Card>
          </Col>
          <Col lg={12}>
            <Form layout="vertical" form={emailForm} onFinish={handleSubmit}>
              <Card className="contact-card">
                <Row gutter={16}>
                  <Col lg={12} sm={24} xs={24}>
                    {" "}
                    <Form.Item
                      name="first_name"
                      label={"First name"}
                      rules={[
                        { required: true, message: "First name is required" },
                      ]}
                    >
                      <Input size="large" />
                    </Form.Item>
                  </Col>
                  <Col lg={12} sm={24} xs={24}>
                    {" "}
                    <Form.Item name="last_name" label={"Last name"}>
                      <Input size="large" />
                    </Form.Item>
                  </Col>
                  <Col lg={24} sm={24} xs={24}>
                    {" "}
                    <Form.Item
                      name="phone_number"
                      label={"Phone number"}
                      rules={[
                        { required: true, message: "Phone number is required" },
                      ]}
                    >
                      <PhoneInput
                        country={"in"}
                        enableSearch={true}
                        inputProps={{
                          required: true,
                          autoFocus: true,
                        }}
                        containerStyle={{
                          width: "100%",
                        }}
                        inputStyle={{
                          width: "100%",
                          height: "40px",
                          fontSize: "14px",
                          paddingLeft: "50px",
                          border: "1px solid #d9d9d9",
                          borderRadius: "8px",
                        }}
                        buttonStyle={{
                          borderRadius: "4px",
                        }}
                        dropdownStyle={{
                          fontSize: "14px",
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col lg={24} sm={24} xs={24}>
                    {" "}
                    <Form.Item
                      name="email"
                      label={"Email address"}
                      rules={[
                        {
                          required: true,
                          message: "Email Address is required",
                        },
                        {
                          type: "email",
                          message: "Enter a valid email address",
                        },
                      ]}
                    >
                      <Input size="large" />
                    </Form.Item>
                  </Col>
                  <Col lg={24} sm={24} xs={24}>
                    {" "}
                    <Form.Item
                      name="subject"
                      label={"Subject"}
                      rules={[
                        { required: true, message: "Subject is required" },
                      ]}
                    >
                      <Input size="large" />
                    </Form.Item>
                  </Col>
                  <Col lg={24} sm={24} xs={24}>
                    {" "}
                    <Form.Item
                      name="message"
                      label={"Message"}
                      rules={[
                        { required: true, message: "Message is required" },
                      ]}
                    >
                      <Input.TextArea rows={4} />
                    </Form.Item>
                  </Col>
                  <Col lg={12} sm={24} xs={24}>
                    <Button
                      className="custom-antd-btn-selected"
                      htmlType="submit"
                      style={{ width: "100%" }}
                    >
                      Submit
                    </Button>
                  </Col>
                </Row>
              </Card>
            </Form>
          </Col>
        </Row>
        <Card
          className="contact-card"
          style={{ background: "#F8F7FF", width: "100%", marginTop: "70px" }}
        >
          <div
            className="section-heading center-text"
            style={{ color: "#211C70" }}
          >
            Visit us
          </div>
          <Row gutter={24} align={"middle"}>
            <Col lg={12}>
              <div>
                <img
                  src={contactUsMap}
                  alt="Location map"
                  className="p-img"
                  // style={{ objectFit: "cover" }}
                />
              </div>
            </Col>
            <Col lg={12}>
              <Flex align="flex-start">
                <EnvironmentOutlined className="contact-list-icon" />{" "}
                <div className="card-content-text">
                  First Floor # 1612, 7th Cross, 19th Main, Sector-1, HSR
                  Layout, Bengaluru, Karnataka, India - 560102{" "}
                </div>
              </Flex>
              <Flex align="flex-start">
                <EnvironmentOutlined className="contact-list-icon" />{" "}
                <div className="card-content-text">
                  C-505, The OYNX, Kalate Business Park, S.No. 186, Kalewadi -
                  Wakad Rd, Near Euro School, Wakad, Pune, Maharashtra - 411057
                  {/* GO Square B wing, Office no 114, 1st Floor, Wakad road, Pune,
                  Maharashtra - 411057{" "} */}
                </div>
              </Flex>
              <Flex align="flex-start">
                <EnvironmentOutlined className="contact-list-icon" />{" "}
                <div className="card-content-text">
                  31 Greylynne Drive, Monroe Township, New Jersey, US - 08831{" "}
                </div>
              </Flex>
              <Flex align="flex-start">
                <EnvironmentOutlined className="contact-list-icon" />{" "}
                <div className="card-content-text">
                  Registered Address: 004 Chinnu Paradise Doddenakundi Bangalore
                  - 560037{" "}
                </div>
              </Flex>
            </Col>
          </Row>
        </Card>
      </div>
    </div>
  );
};
export default ContactUs;
